import {
  Header1,
  Instruction,
  InstructionWithContent,
} from "../../BlockComponent";
import {
  ButtonGroup,
  GuideTypographyLine,
  LineWithSolidLabel,
  TypographyLine,
} from "../../CellComponent";
import { LastCard } from "../common";

export const Content_10_2_A = [
  Header1("typography_0"),
  Instruction("typography_1"),
  Instruction("typography_2"),
  Instruction("typography_3"),

  Header1("typography_4"),
  Instruction("typography_5"),
  Instruction("typography_6"),
  Instruction("typography_7"),

  InstructionWithContent(`typography_8`, [
    [
      ButtonGroup(
        [
          { text: "A. 내 잘못이 무엇인지 자책한다." },
          { text: "B. 반박할 말을 머릿속으로 계산한다." },
          { text: "C. 긍정적인 상황이라고 세뇌한다." },
          { text: "D. 마음속에서 일어나는 일들을 관찰한다." },
        ],
        { id: "quiz1", vertical: true }
      ),
    ],
    GuideTypographyLine("typography_quiz1_incorrect", {
      answerList: [{ id: "quiz1", answerIndex: 3 }],
    }),
  ]),

  Instruction("typography_9"),

  Header1("typography_10"),
  InstructionWithContent(`typography_11`, [
    ...LineWithSolidLabel(
      "인지하기 (R, Recognition)",
      TypographyLine("typography_rain_r")
    ),
    ...LineWithSolidLabel(
      "수용하기 (A, Acceptance)",
      TypographyLine("typography_rain_a")
    ),
    ...LineWithSolidLabel(
      "살펴보기 (I, Investigation)",
      TypographyLine("typography_rain_i")
    ),
    ...LineWithSolidLabel(
      "탈동일시 (N, Non-identification)",
      TypographyLine("typography_rain_n")
    ),
  ]),
  Instruction("typography_12"),

  Header1("typography_13"),
  Instruction("typography_14"),
  Instruction("typography_15"),
  Instruction("typography_16"),

  Header1("typography_17"),
  Instruction("typography_18"),
  Instruction("typography_19"),

  InstructionWithContent(`typography_20`, [
    [
      ButtonGroup(
        [
          { text: "A. 매일 스스로에게 긍정적인 말 해주기" },
          { text: "B. 아무 생각 없이 머릿속을 비워내기" },
          { text: "C. 마음속 생각 및 감정들과 건강한 관계 맺기" },
        ],
        { id: "quiz2", vertical: true }
      ),
    ],
    GuideTypographyLine("typography_quiz2_incorrect", {
      answerList: [{ id: "quiz2", answerIndex: 2 }],
    }),
  ]),

  Instruction("typography_21"),

  ...LastCard,
];
